import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import IkiSymbol from '@/components/IkiSymbol';
import cardsData from '@/data/scientific_foundation_cards_en.json';
import fullData from '@/data/scientific_foundation_full_en.json';
import '@/styles/ScientificFoundation.css';

function ScientificFoundation() {
  const navigate = useNavigate();
  const [selectedCard, setSelectedCard] = useState(null);

  const handleCardClick = (cardId) => {
    const fullContent = fullData.scientific_foundation_full.find(item => item.id === cardId);
    setSelectedCard(fullContent);
  };

  const closeModal = () => {
    setSelectedCard(null);
  };

  return (
    <div className="scientific-foundation-container">
      {/* Back Button */}
      <button
        onClick={() => window.history.back()}
        style={{
          position: 'fixed',
          top: '20px',
          left: '20px',
          zIndex: 1000,
          padding: '12px 20px',
          background: 'rgba(255, 255, 255, 0.95)',
          color: '#1E6B68',
          border: '2px solid #B8D3CF',
          borderRadius: '24px',
          fontSize: '1rem',
          fontWeight: '600',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          boxShadow: '0 4px 12px rgba(30, 107, 104, 0.15)',
          transition: 'all 0.2s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#1E6B68';
          e.currentTarget.style.color = '#fff';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'rgba(255, 255, 255, 0.95)';
          e.currentTarget.style.color = '#1E6B68';
        }}
      >
        ← Back
      </button>

      <div className="scientific-header">
        <h1>Scientific Foundation</h1>
        <p className="header-subtitle">
          Understanding the neuroscience, breathwork, sound and ritual behind transformation
        </p>
      </div>

      <div className="foundation-cards-grid">
        {cardsData.scientific_foundation_cards.map((card, index) => (
          <div
            key={card.id}
            className="foundation-card"
            onClick={() => handleCardClick(card.id)}
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 8 }}>
              <div className="card-number">{index + 1}</div>
              {card.badge && (
                <span style={{ fontSize: '0.6rem', fontWeight: '700', letterSpacing: '0.07em', textTransform: 'uppercase', background: 'rgba(30,107,104,0.1)', color: '#1E6B68', padding: '3px 8px', borderRadius: 8 }}>
                  {card.badge}
                </span>
              )}
            </div>
            <h3>{card.title}</h3>
            <p>{card.short_text}</p>
            {card.refs && (
              <div style={{ marginTop: 8, borderTop: '1px solid rgba(184,211,207,0.3)', paddingTop: 8 }}>
                {card.refs.map((ref, i) => (
                  <p key={i} style={{ margin: '0 0 3px', fontSize: '0.62rem', color: '#8FA3A0', lineHeight: 1.4 }}>· {ref}</p>
                ))}
              </div>
            )}
            <div className="card-arrow">
              <IkiSymbol name="chevron-right" size={20} />
            </div>
          </div>
        ))}
      </div>

      {/* Modal for Full Content */}
      {selectedCard && (
        <div className="foundation-modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              <IkiSymbol name="close" size={24} />
            </button>

            <h2>{selectedCard.title}</h2>
            <div className="modal-text">
              <p>{selectedCard.full_text}</p>
            </div>

            {/* References from cards data */}
            {(() => {
              const cardMeta = cardsData.scientific_foundation_cards.find(c => c.id === selectedCard.id);
              return cardMeta?.refs?.length ? (
                <div style={{ marginTop: 20, paddingTop: 16, borderTop: '1px solid rgba(184,211,207,0.3)' }}>
                  <p style={{ fontSize: '0.7rem', fontWeight: '700', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#8FA3A0', marginBottom: 8 }}>References</p>
                  {cardMeta.refs.map((ref, i) => (
                    <p key={i} style={{ margin: '0 0 5px', fontSize: '0.72rem', color: '#6B8B87', lineHeight: 1.5 }}>{i + 1}. {ref}</p>
                  ))}
                </div>
              ) : null;
            })()}

            <button className="btn-close-modal" onClick={closeModal}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ScientificFoundation;
